import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import React, { useContext, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import DragIndicatorIcon from 'assets/images/Category/DragIndicatorIcon.png';
import CheckBoxInput from 'components/common/Input/CheckBoxInput';
import CaretUpIcon from 'assets/images/Category/CaretUp.png';
import CaretDownIcon from 'assets/images/Category/CaretDown.png';
import EditUnderlineIcon from 'assets/images/Category/editUnderlineIcon.png';
import AddServiceIcon from 'assets/images/Category/AddServiceIcon.png';
import DescriptionIcon from 'assets/images/Category/DescriptionIcon.png';
import DeleteIcon from 'assets/images/Category/DeleteIcon.png';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormattedMessage } from 'react-intl';
import CustomPopover from 'components/common/CustomPopover';
import SubServiceList from './SubServiceList';
import { useNavigate } from 'react-router-dom';
import { superAdminEditService } from 'routes/AppUrls';
import { LocaleContext } from 'routes/Router';
import { useDispatch } from 'react-redux';
import {
  basicDetailsCallApi,
  SUB_SERVICE_DETAILS,
} from 'store/SuperAdmin/basicDetails/action';
import SortableSubServiceList from './SortableSubServiceList';

const SortableList = ({
  services,
  onEdit,
  onCheckBoxEnableDisable,
  onDelete,
  onDeleteSubService,
  onAddService,
  onDragEnd, // new prop to update order
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [expanded, setExpanded] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [
    {
      label: <FormattedMessage id="Add Service" />,
      icon: <Image src={AddServiceIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onAddService(viewData),
    },
    {
      label: <FormattedMessage id="Edit Sub-Category" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onEdit(viewData),
    },
    {
      label: <FormattedMessage id="Delete" />,
      icon: <Image src={DeleteIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onDelete(viewData),
    },
  ];

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleEditSubService = (data) => {
    dispatch(basicDetailsCallApi(SUB_SERVICE_DETAILS, data));
    navigate(superAdminEditService(locale));
  };

  const handleDeleteSubService = (data) => {
    onDeleteSubService(data);
  };

  // const handleDragEnd = (result) => {
  //   const { source, destination } = result;
  //   if (!destination) return;

  //   const sourceServiceId = source.droppableId.replace('sub-', '');
  //   const destinationServiceId = destination.droppableId.replace('sub-', '');

  //   // Only allow reorder inside same parent
  //   if (sourceServiceId !== destinationServiceId) return;

  //   const updatedServices = [...services];
  //   const serviceIndex = updatedServices.findIndex(
  //     (service) => service.id.toString() === sourceServiceId
  //   );

  //   const subServiceList = [...updatedServices[serviceIndex].sub_services];
  //   const [removed] = subServiceList.splice(source.index, 1);
  //   subServiceList.splice(destination.index, 0, removed);

  //   updatedServices[serviceIndex].sub_services = subServiceList;
  //   console.log(updatedServices);
  //   // setServices(updatedServices); // or call a parent handler
  // };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="service-droppable">
        {(provided) => (
          <Row
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="m-0 p-0 mt-3"
          >
            {services.map((service, index) => (
              <Draggable
                key={service.id}
                draggableId={service.id.toString()}
                index={index}
              >
                {(provided, snapshot) => (
                  <Row
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps} // drag handle here
                    className={`m-0 p-0  ${services?.length === index + 1 ? 'pt-4' : 'border-b py-4'}`}
                  >
                    {onEdit ? (
                      <Col md={6} className="items-center">
                        <div className="flex items-center gap-2">
                          <img
                            src={DragIndicatorIcon}
                            alt={'icon'}
                            style={{ height: '32px', width: '32px' }}
                          />
                          <CheckBoxInput
                            height={'32px'}
                            onChange={() => onCheckBoxEnableDisable(service)}
                            checked={service?.status}
                          />
                          {service?.sub_services?.length > 0 && (
                            <button
                              className="expand-btn text-lg"
                              onClick={() => toggleExpand(service.id)}
                              aria-label={`Toggle sub-services for ${service.name}`}
                            >
                              {expanded[service.id] ? (
                                <img
                                  src={CaretUpIcon}
                                  alt={'icon'}
                                  style={{
                                    height: '24px',
                                    width: '24px',
                                  }}
                                />
                              ) : (
                                <img
                                  src={CaretDownIcon}
                                  alt={'icon'}
                                  style={{
                                    height: '24px',
                                    width: '24px',
                                  }}
                                />
                              )}
                            </button>
                          )}
                          <span className="service-name font-bold">
                            {service.title}
                          </span>
                        </div>
                      </Col>
                    ) : (
                      <Col md={6} className="items-center">
                        <p className="service-name font-bold">
                          {service.product_name_en}
                        </p>
                      </Col>
                    )}

                    <Col md={3}></Col>

                    {onEdit ? (
                      <Col md={3} className="">
                        <Stack
                          direction="horizontal"
                          gap={4}
                          className="items-center justify-end"
                        >
                          <div>
                            <MoreVertIcon
                              aria-describedby={id}
                              style={{
                                fill: '#3C1053',
                                cursor: 'pointer',
                              }}
                              onClick={(e) => handlePopoverClick(e, service)}
                            />
                            <CustomPopover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              handleClose={handlePopoverClose}
                              options={PopoverData}
                            />
                          </div>
                        </Stack>
                      </Col>
                    ) : (
                      <Col md={3} className="text-end">
                        {service?.child?.length > 0 && (
                          <button
                            className="expand-btn text-lg"
                            onClick={() => toggleExpand(service.id)}
                            aria-label={`Toggle sub-services for ${service.product_name_en}`}
                          >
                            {expanded[service.id] ? (
                              <img
                                src={CaretUpIcon}
                                alt={'icon'}
                                style={{ height: '24px', width: '24px' }}
                              />
                            ) : (
                              <img
                                src={CaretDownIcon}
                                alt={'icon'}
                                style={{ height: '24px', width: '24px' }}
                              />
                            )}
                          </button>
                        )}
                      </Col>
                    )}

                    {onEdit ? (
                      <Row className="m-0 p-0">
                        {expanded[service.id] &&
                          service?.sub_services?.length > 0 && (
                            <div className="">
                              <SubServiceList
                                services={service.sub_services}
                                onEdit={(data) => handleEditSubService(data)}
                                onCheckBoxEnableDisable={
                                  onCheckBoxEnableDisable
                                }
                                onDelete={(data) =>
                                  handleDeleteSubService(data)
                                }
                              />

                              {/* <SortableSubServiceList
                                services={service}
                                onEdit={(data) => handleEditSubService(data)}
                                onCheckBoxEnableDisable={
                                  onCheckBoxEnableDisable
                                }
                                onDelete={(data) =>
                                  handleDeleteSubService(data)
                                }
                                onDragEnd={handleDragEnd}
                              /> */}
                            </div>
                          )}
                      </Row>
                    ) : (
                      <Row className="m-0 p-0">
                        {expanded[service.id] && service?.child?.length > 0 && (
                          <div className="">
                            <SubServiceList
                              services={service.child}
                              // onEdit={(data) => handleEditSubService(data)}
                              // onDelete={(data) => handleDeleteSubService(data)}
                            />

                            {/* <SortableSubServiceList
                              services={service}
                              // onEdit={(data) => handleEditSubService(data)}
                              // onDelete={(data) => handleDeleteSubService(data)}
                              onDragEnd={handleDragEnd}
                            /> */}
                          </div>
                        )}
                      </Row>
                    )}
                  </Row>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Row>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SortableList;
